// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Sign/ForgotPassword/ForgotPassword.css */

.forgot-password-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #364C63;
    height: 85vh;
    margin-top: -0.5rem;
}

.forgot-password-page h2 {
    color: #EF6F53;
    text-align: center;
    font-size: 1.5rem;
    font-weight: bold;
    letter-spacing: 0.05rem;
    margin-bottom: 1rem;
    margin-top: 1rem;
}

.forgot-password-container {
    background: white;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    margin-top: 1rem;
    width: 100%;
    max-width: 450px;
}

.form-groupiee {
    margin-bottom: 15px;
}

.form-groupiee label {
    display: block;
    margin-bottom: 5px;
    color: #364C63;
}

.form-groupiee input {
    width: 100%;
    padding: 5px;
    border: 1px solid #ddd;
    border-radius: 10px;
}

.form-groupiee input:focus {
    border-color: #EF6F53;
}

.btn-forgot {
    width: 50%;
    padding: 0.25rem;
    background-color: #EF6F53;
    color: white;
    border: none;
    border-radius: 10px;
    cursor: pointer;
}

.btn-forgot:hover {
    background-color: #d15846;
}

.btn-forgot:disabled {
    background-color: #EF6F53;
    cursor: not-allowed;
}

.successs-message {
    margin: auto;
    color: green;
    margin-top: 10px;
    padding: 0.25rem;
}

.errorr-message {
    margin: auto;
    color: red;
    margin-top: 10px;
    padding: 0.25rem;
}

.back-to-login {
    text-align: center;
    margin-top: 1rem;
}

.back-to-login a {
    color: #007bff;
    text-decoration: none;
    font-size: 1rem;
}

.back-to-login a:hover {
    text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/components/routes/Sign/ForgotPassword/ForgotPassword.css"],"names":[],"mappings":"AAAA,iEAAiE;;AAEjE;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,yCAAyC;IACzC,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":["/* src/components/routes/Sign/ForgotPassword/ForgotPassword.css */\n\n.forgot-password-page {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background-color: #364C63;\n    height: 85vh;\n    margin-top: -0.5rem;\n}\n\n.forgot-password-page h2 {\n    color: #EF6F53;\n    text-align: center;\n    font-size: 1.5rem;\n    font-weight: bold;\n    letter-spacing: 0.05rem;\n    margin-bottom: 1rem;\n    margin-top: 1rem;\n}\n\n.forgot-password-container {\n    background: white;\n    padding: 30px;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    margin-top: 1rem;\n    width: 100%;\n    max-width: 450px;\n}\n\n.form-groupiee {\n    margin-bottom: 15px;\n}\n\n.form-groupiee label {\n    display: block;\n    margin-bottom: 5px;\n    color: #364C63;\n}\n\n.form-groupiee input {\n    width: 100%;\n    padding: 5px;\n    border: 1px solid #ddd;\n    border-radius: 10px;\n}\n\n.form-groupiee input:focus {\n    border-color: #EF6F53;\n}\n\n.btn-forgot {\n    width: 50%;\n    padding: 0.25rem;\n    background-color: #EF6F53;\n    color: white;\n    border: none;\n    border-radius: 10px;\n    cursor: pointer;\n}\n\n.btn-forgot:hover {\n    background-color: #d15846;\n}\n\n.btn-forgot:disabled {\n    background-color: #EF6F53;\n    cursor: not-allowed;\n}\n\n.successs-message {\n    margin: auto;\n    color: green;\n    margin-top: 10px;\n    padding: 0.25rem;\n}\n\n.errorr-message {\n    margin: auto;\n    color: red;\n    margin-top: 10px;\n    padding: 0.25rem;\n}\n\n.back-to-login {\n    text-align: center;\n    margin-top: 1rem;\n}\n\n.back-to-login a {\n    color: #007bff;\n    text-decoration: none;\n    font-size: 1rem;\n}\n\n.back-to-login a:hover {\n    text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
